import { useUser } from "@/app/context/UserContext";
import { iProProjectMain } from "@/app/models/interfaceProject";
import { useState, useEffect, use } from "react";
import { Check, ChevronLeft, ChevronRight, Pencil, Plus, Search, Trash2, X } from "lucide-react";
import { iQuotaUser } from "@/app/models/interfaceQuotaConfiguration";
import { AlertType, QuotaUserStatus } from "@/app/constants/enums";
import { validationProjectCuota } from "@/app/helpers/functions";

export default function QuotaUser() {
    const { userProject, setUserProject,addAlert } = useUser();

    // Estados
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const itemsPerPage = 5;

    const [viewAdd, setViewAdd] = useState(false);
    const [newUser, setNewUser] = useState("");
    const [newQuota, setNewQuota] = useState<number>(0);

    const [editingUser, setEditingUser] = useState<string | null>(null);
    const [editUser, setEditUser] = useState("");
    const [editQuota, setEditQuota] = useState<number>(0);
    const [error, setError] = useState("");
    const [errorEdit, setErrorEdit] = useState("");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // --- CRUD ---
    const validateQuota = (user:string, quota: number, type:string) => { 
        if(type==="add"){ 
            if(!user.trim()){ setError("El correo del usuario es obligatorio."); return false; }
            if(quota <= 0){ setError("La cuota es obligatoria."); return false; }
            if (!emailRegex.test(newUser)) { setError("Formato de correo inválido");return false;} 
            const exists = userProject?.project?.users?.some( (u) => u.user.toLowerCase() === user.toLowerCase() );
            if (exists) { setError("El usuario ya fue agregado."); return false; } 
            // validacion del projecto cuota total de proyecto  
            const val = validationProjectCuota(userProject,quota); 
            if(val.status===false){ 
                setError(val.message);
                return val.status;
            }
            setError("");
        }else {
            if(!editUser.trim()){ setErrorEdit("El correo del usuario es obligatorio."); return false; }
            if(quota <= 0){ setErrorEdit("La cuota es obligatoria."); return false; }
            if (!emailRegex.test(editUser)) { setErrorEdit("Formato de correo inválido");return false;} 
            const exists = userProject?.project?.users?.some( (u) => u.user.toLowerCase() === editUser.toLowerCase() && u.user?.toLowerCase()!==user.toLowerCase() );
            if (exists) { setErrorEdit("El usuario ya fue agregado."); return false; } 
            // validacion del projecto cuota total de proyecto 
            const val = validationProjectCuota(userProject,
                userProject.project.users.find(O=>O.user.toLowerCase()===user.toLowerCase())?.quota??0,
                quota ); 
            if(val.status===false){ 
                setErrorEdit(val.message);
                return val.status;
            }

            setErrorEdit("");
        }
        return true;
    };

    const handleAdd = () => {    
        if (!validateQuota(newUser,newQuota, "add")) return;  
        setUserProject((prev: iProProjectMain) => ({
            ...prev,
            project: {
            ...prev.project,
            users: [{ user: newUser, quota: newQuota, status: QuotaUserStatus.New },...prev.project.users]
            }
        }));
        setNewUser("");
        setNewQuota(0);
        setViewAdd(false);
    };

    const startAdd = () => {
        setViewAdd(true);
        setNewUser("");
        setNewQuota(0);
        setError("");
    }

    const changeEdit = (u: iQuotaUser) => {
        setEditUser(u.user);
        setEditQuota(u.quota);
        setEditingUser(u.user);
        setErrorEdit("");
    };

    const handleEdit = (user: string) => {
        if (!validateQuota(user, editQuota, "edit")) return;
        setUserProject((prev: iProProjectMain) => {
            const updatedUsers = prev.project.users.map((u) =>
            u.user === user ? { ...u, user: editUser, quota: editQuota, status: u.status === QuotaUserStatus.New?QuotaUserStatus.New : QuotaUserStatus.Updated } : u
            );
            return { ...prev, project: { ...prev.project, users: updatedUsers } };
        });
        setEditingUser(null);
        setEditUser("");
        setEditQuota(0);
        setErrorEdit("");
    };

    const handleDelete = (user: string) => {
        setUserProject((prev: iProProjectMain) => {
            const updatedUsers = prev.project.users.map((u) =>
            u.user === user ? { ...u, status: QuotaUserStatus.Deleted } : u
            );
            return { ...prev, project: { ...prev.project, users: updatedUsers } };
        });
    };
    // estados:
    // --- Search & Paginación ---
    const users = userProject?.project?.users ?? [];
    const filteredData = users
        .filter((u) => u.status !== QuotaUserStatus.Deleted)
        .filter((u) => u.user.toLowerCase().includes(search.trim().toLowerCase()));        
    const paginatedData = filteredData.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    useEffect(() => {
        setPage(1);
    }, [filteredData.length]);

    return (
        <div className="w-full p-4 pt-1" key={users.length}>
            {/* Formulario en una sola fila */} 
            <div className="flex justify-end mb-3">
                <span className="font-semibold px-2 py-2">Agregar Usuario</span>
                <button
                    onClick={() => startAdd()}
                    className="flex items-center btn-inca-secondary justify-center px-2 py-2 w-10 h-10 rounded-full bg-gray-100 transition-colors border shadow-md  hover:bg-gray-200 animate-fade-in"
                    title="Agregar Usuario"    
                >
                    <Plus className="w-6 h-6" strokeWidth={1.5} />
                </button>                
            </div>


            {/* Search */}
            {((userProject?.project?.users ?? []).filter((u) => u.status !== QuotaUserStatus.Deleted).length > itemsPerPage) && (
                <div className="relative flex-1 mb-4">
                    <input
                        type="text"
                        placeholder="Buscar usuario..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="w-full border rounded n-fmr-input-search border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                    />
                    <Search className="absolute right-2.5 top-3.5 text-gray-400" size={18} />
                </div>
            )}

            
            

            {/* Listado en una sola fila */}

        <div className="grid grid-cols-4 font-medium text-gray-700 border-b pb-2">
            <div className="col-span-2 font-semibold">Usuario</div>
            <div className="col-span-1 text-center font-semibold">Cuota</div>
            <div className="col-span-1 text-center font-semibold">Acción</div>
        </div>
        
        {viewAdd && (
                <div className="grid grid-cols-4 items-center border-b py-2 text-sm animate-fade-in" >
                    
                    <div className="col-span-2 pr-2">   
                        <input
                        type="text"
                        placeholder="Correo del usuario"
                        value={newUser}
                        onChange={(e) => setNewUser(e.target.value.toLowerCase())}
                        className="w-full border n-fmr-input px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                        />
                    </div>
                    <div className="col-span-1 pr-2 relative ml-5"> 
                        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500"> $ </span>  
                        <input
                        type="number"
                        min={1}
                        step="0.01" 
                        value={newQuota}
                        onChange={(e) => setNewQuota(Number(e.target.value))}
                        className="w-full pl-6 border n-fmr-input px-3 py-2 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-700 text-right"
                        /> 
                    </div>
                    <div className="col-span-1 flex justify-center gap-2">
                        <button
                        onClick={handleAdd}
                        className="flex items-center text-white justify-center px-2 py-2 rounded-full bg-blue-600 transition-colors border shadow-md hover:bg-blue-800"
                        >
                        <Check className="w-4 h-4" />
                        </button>
                        <button
                        onClick={() => setViewAdd(false)}
                        className="flex items-center btn-inca-secondary justify-center px-2 py-2 rounded-full transition-colors border shadow-md"
                        >
                        <X className="w-4 h-4" />
                        </button>
                    </div>
                
                    {error && <div className="col-span-4 pr-2"> <p className=" text-red-500 text-sm">{error}</p></div>}
                </div>
                

            )}

            
        {paginatedData.map((item) => (
        <div
            key={item.user}
            className="grid grid-cols-4 items-center border-b py-2 text-sm"
        >
            {editingUser === item.user ? (
            <>
                {/* Usuario */}
                <div className="col-span-2 pr-2">
                    <input
                        type="text"
                        value={editUser}
                        onChange={(e) => setEditUser(e.target.value.toLowerCase())}
                        className="w-full border n-fmr-input px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700"
                    /> 
                </div>
                {/* Cuota */}
                <div className="col-span-1 pr-2 relative ml-5">
                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500"> $ </span>
                    <input
                        type="number"
                        min={1}
                        value={editQuota}
                        step="0.01"
                        onChange={(e) => setEditQuota(Number(e.target.value))}
                        className="w-full pl-6 border n-fmr-input px-3 py-2 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-700 text-right"
                    /> 
                </div>
            </>
            ) : (
            <>
                <div className="col-span-2 font-medium pl-2">{item.user}</div>
                <div className="col-span-1 text-center text-gray-600">{item.quota}</div>
            </>
            )}

            {/* Acción */}
            <div className="col-span-1 flex justify-center gap-2">
                <button
                    onClick={() =>
                    editingUser === item.user ? handleEdit(item.user) : changeEdit(item)
                    }
                    className="flex items-center text-white justify-center px-2 py-2 rounded-full bg-blue-600 transition-colors border shadow-md hover:bg-blue-800"
                >
                    {editingUser === item.user ? (
                    <Check className="w-4 h-4" />
                    ) : (
                    <Pencil className="w-4 h-4" />
                    )}
                </button>
                <button
                    onClick={() =>
                        editingUser === item.user ? setEditingUser(null) : handleDelete(item.user)
                    }
                    className="flex items-center btn-inca-secondary justify-center px-2 py-2 rounded-full transition-colors border shadow-md"
                >
                     {editingUser === item.user ? (
                        <X className="w-4 h-4" />
                    ) : (
                        <Trash2 className="w-4 h-4" />
                    )} 
                </button>
            </div>
            
            {errorEdit&&(editingUser === item.user)&& ( <div className="col-span-4 pr-2"><p className="text-red-500 text-sm ">{errorEdit}</p></div> )}
                     

        </div>
        ))}

            {/* Paginación */}
            {filteredData.length > itemsPerPage && (
            <div className="flex justify-end items-center mt-2 gap-2">
                <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className="p-1 border bg-slate-50 text-blue-500 rounded-full disabled:opacity-50 shadow-lg"
                >
                <ChevronLeft />
                </button>
                <span className="px-3 py-1 bg-blue-700 text-white rounded-full">
                {page} / {Math.ceil(filteredData.length / itemsPerPage)}
                </span>
                <button
                onClick={() =>
                    setPage((prev) =>
                    page * itemsPerPage < filteredData.length ? prev + 1 : prev
                    )
                }
                disabled={page * itemsPerPage >= filteredData.length}
                className="p-1 border bg-slate-50 text-blue-500 rounded-full disabled:opacity-50 shadow-lg"
                >
                <ChevronRight />
                </button>
            </div>
            )}
        </div>
        );
}
